export default __webpack_public_path__ + "static/media/Bscrum1.8e4a447b.png";